import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import withStyles from '@tempus/component-library/utils/withStyles';
import typography from '@tcl-boron-styles/typography/dist/index.module.css';
import cn from 'classnames';
import GooglePlayBadge from './assets/GooglePlayBadge';
import AppStoreBadge from './assets/AppStoreBadge';
import { TempusLogoSmall } from './assets/TempusLogoSmall';
import OrbVideo from './assets/videos/Tempus-Orb_1080p.mp4';
import AppRouter from './navigation/router';
import styles from './styles';

function App({ classes }) {
  const [applyTransition, setApplyTransition] = React.useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setApplyTransition(true), 10);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={classes.root}>
      <div className={`${classes.left} ${applyTransition ? classes.show : classes.hide}`}>
        <div className={classes.widgetContainer}>
          <div className={classes.logoContainer}>
            <TempusLogoSmall />
          </div>
          <div className={classes.pageContainer}>
            <AppRouter />
          </div>
          <div className={classes.contact}>
            <span className={cn(typography.body, classes.contactInfo)}>(800) 739 - 4137</span>
            <span className={cn(typography.body, classes.contactInfo)}>support@tempus.com</span>
          </div>
        </div>
      </div>
      <div className={`${classes.rightContainer} ${classes.right} ${applyTransition ? classes.show : classes.hide}`}>
        <video className={classes.video} loop muted autoPlay playsInline src={OrbVideo} />
        <div className={classes.badgeGoogle}>
          <GooglePlayBadge />
        </div>
        <div className={classes.badgeApple}>
          <AppStoreBadge />
        </div>
      </div>
    </div>
  );
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);
